import {
    /** FETCH APPLICATION  */
    FETCH_ADDNOTETOAPPLICATION_FULFILLED,
    FETCH_ADDNOTETOAPPLICATION_REJECTED,
    FETCH_ADDNOTETOAPPLICATION_PENDING,
    RESET_ADDNOTETOAPPLICATION
} from "../../actions/nurse/addNoteToApplication";
const initialState = {
    done: false,
    error: false,
    spinner: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH_ADDNOTETOAPPLICATION_PENDING:
            return {
                done: false,
                error: false,
                spinner: true
            };
        case FETCH_ADDNOTETOAPPLICATION_FULFILLED:
            return {
                ...state,
                addNoteToApplication: action.payload,
                done: true,
                spinner: false
            };
        case FETCH_ADDNOTETOAPPLICATION_REJECTED:
            return {
                ...state,
                error: action.payload,
                done: false,
                spinner: false
            };
        case RESET_ADDNOTETOAPPLICATION:
            return {
                initialState,
                done: false,
                error: false,
                spinner: false
            };
        default:
            return state;
    }
};